"use client";

import { api } from "~/trpc/react";
import ProductListing from "./product-listing";
import { ProductProps } from "~/types/types";
import { ProductSearchParams } from "~/schemas/Products";

const ProductReel: React.FC<ProductSearchParams> = ({ query }) => {
  const FALLBACK_LIMIT = 4;
  const isHome = !query.home;

  const { isLoading, data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    api.products.getAllProducts.useInfiniteQuery(
      {
        limit: query.limit ?? FALLBACK_LIMIT,
        query,
      },
      {
        refetchOnWindowFocus: false,
        getNextPageParam: (lastPage) => (isHome ? lastPage?.nextId : undefined),
      },
    );

//   const { viewRef } = usePagination({ hasNextPage, fetchNextPage });

  const products = data?.pages.flatMap((page) => page.products) ?? [];

  const map: ((typeof products)[number] | null)[] = isLoading
    ? new Array<null>(query.limit ?? FALLBACK_LIMIT).fill(null)
    : products;

  if (map.length > 0) {
    return (
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {map.map((product, i) => (
          <ProductListing
            key={`product-${i}`}
            product={product as ProductProps}
            index={i}
          />
        ))}
        {/* <span ref={viewRef} />
        {isFetchingNextPage && <span>Loading...</span>} */}
      </div>
    );
  } else {
    return (
        <div />
    //   <NotFound
    //     title="Nothing was found."
    //     description="It looks like you haven't liked any products yet."
    //     homeButton
    //   />
    );
  }
};

export default ProductReel;
